export enum EField {
  DateOfBirth = "dateOfBirth",
  PlaceOfBirth = "placeOfBirth",
  countryOfBirth = "countryOfBirth",
  Nationality = "nationality",
}
